"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { padding: '20px 16px' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "surface-table-row", css: {
                display: 'flex',
                flexDirection: 'column',
                rowGap: '6px',
                padding: '12px 16px',
                borderRadius: '8px',
            } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "subtitle3 gray-80" }, { children: `${t('폰디앱 사용하면')} → ${t('앱 알림 받아요')} :)` })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "caption1 gray-40" }, { children: t('결제한 구매자 문의는 작가님께 카카오 알림톡도 발송 돼요.') }))] })) })));
}
exports.default = default_1;
